import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHourglassEnd,
  faUserCircle,
  faAddressCard,
  faCoins,
  faChevronCircleUp,
} from "@fortawesome/free-solid-svg-icons";

// const handleScrollUpBtn = () => {
//   console.log("scroll");
// };

const HIWB = () => {
  useEffect(() => {
    window.onscroll = () => {
      const header = document.querySelector(".header");
      const scrollBtn = document.querySelector("#scrollUpBtn");
      if (!scrollBtn) return;
      if (header?.getBoundingClientRect().top + header?.getBoundingClientRect().height > 0) {
        scrollBtn.style.bottom = "-4rem";
      } else if (header) scrollBtn.style.bottom = "4rem";
    };
  }, []);

  return (
    <section id="hiwb" className="section hiwb" aria-labelledby="hiwb-title">
      <div id="scrollUpBtn" className="hiwb__scroll">
        <a href="/#" aria-label="Remonter en haut de la page">
          <FontAwesomeIcon icon={faChevronCircleUp} className="hiwb__scroll-icon" />
        </a>
      </div>

      <div className="hiwb__container">
        <div className="hiwb__content">
          <h2 id="hiwb-title" className="hiwb__title">Comment ça marche pour votre commerce ?</h2>

          <div className="hiwb__step hiwb__step--1">
            <FontAwesomeIcon icon={faUserCircle} className="hiwb__icon" aria-hidden="true" />
            <div className="hiwb__step-body">
              <div className="hiwb__step-title">
                <h3>1. Créez un compte</h3>
                <div className="hiwb__step-meta">
                  <FontAwesomeIcon icon={faHourglassEnd} className="hiwb__meta-icon" aria-hidden="true" />
                  <time className="hiwb__duration" dateTime="PT1M">1 min</time>
                </div>
              </div>
              <p className="hiwb__step-desc">
                Renseignez simplement le nom de votre commerce et un email afin de créer un compte. Vous recevrez immédiatement un mot de passe pour vous connecter.
              </p>
            </div>
          </div>

          <div className="hiwb__step hiwb__step--2">
            <FontAwesomeIcon icon={faAddressCard} className="hiwb__icon" aria-hidden="true" />
            <div className="hiwb__step-body">
              <div className="hiwb__step-title">
                <h3>2. Complétez vos informations</h3>
                <div className="hiwb__step-meta">
                  <FontAwesomeIcon icon={faHourglassEnd} className="hiwb__meta-icon" aria-hidden="true" />
                  <time className="hiwb__duration" dateTime="PT10M">10 min</time>
                </div>
              </div>
              <p className="hiwb__step-desc">
                Connectez-vous, fournissez les coordonnées de votre commerce et personnalisez
                votre carte de fidélité. Vous aurez le choix entre une carte à 10, 11 ou 15 tampons. Ensuite, activez votre compte.
              </p>
            </div>
          </div>

          <div className="hiwb__step hiwb__step--3">
            <FontAwesomeIcon icon={faCoins} className="hiwb__icon" aria-hidden="true" />
            <div className="hiwb__step-body">
              <div className="hiwb__step-title">
                <h3>3. Commencez à fidéliser vos clients</h3>
                <div className="hiwb__step-meta">
                  <FontAwesomeIcon icon={faHourglassEnd} className="hiwb__meta-icon" aria-hidden="true" />
                  <span className="hiwb__duration">instantanément</span>
                </div>
              </div>
              <p className="hiwb__step-desc">
                Votre carte de fidélité est visible par vos clients sur
                l'application Carte Verte et prête à être ajoutée à leurs
                portefeuilles virtuels. Grâce au code QR sécurisé (valable
                une seule fois) qui sera affiché
                sur votre téléphone/tablette dans votre magasin, les clients
                peuvent le scanner et ainsi cumuler des tampons virtuels.
              </p>
            </div>
          </div>

              <Link to="/signup" className="hiwb__cta createButton">
            Adhérer
          </Link>
        </div>

        <div className="hiwb__media">
          <img src="/images/hiwb2.jpg" alt="Illustration — Comment ça marche pour votre commerce" />
        </div>
      </div>
    </section>
  );
};

export default HIWB;
